import styled from "styled-components";

export const StyledSVG = styled.svg`
  min-width: 1rem;
  width: 1rem;
  height: 2.75rem;
`;
